import AWS from 'aws-sdk';
// import keys from '../config/index.js';
import {accounts} from '../../../universal/resources/accounts.json';
import {regions} from '../../../universal/resources/regions.json';

export default credentials => {

  // create a new STS instance for the purpose of assuming roles in other accounts.
  const STS = new AWS.STS({
    region: 'eu-west-1',
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken
  });

  //Declare all instances outside the promise.
  const allInstances = [];

  //Total number of account/region combinations.
  const totalProfiles = accounts.length * regions.length;
  // const totalProfiles = 1;
  let currentProfile = 0;

  return new Promise((resolve, reject) => {

    regions.forEach(region => {
      accounts.forEach(account => {
        // regions.slice(12, 13).forEach(region => {
        //     accounts.slice(0,1).forEach(account => {

        let EC2;

        // console.log(region, account)

        new Promise((resolve, reject) => {
          // due to our account already being in the root account we can't assume a role within it so we must use the
          // root credentials to access it. This empty promise allows us to control this flow.

          if (account.id === '704490916269') {
            // root account. Pass through the credentials.
            resolve({
              Credentials: {
                AccessKeyId: credentials.accessKeyId,
                SecretAccessKey: credentials.secretAccessKey,
                SessionToken: credentials.sessionToken
              }
            });
          } else {

            const policy = JSON.stringify({
              'Version': '2012-10-17',
              'Statement': [
                {
                  'Sid': 'VisualEditor0',
                  'Effect': 'Allow',
                  'Action': ['ec2:DescribeReservedInstances'],
                  'Resource': '*'
                }
              ]
            });

            // every other account. Obtain temporary credentials.
            resolve(STS.assumeRole({
              RoleArn: `arn:aws:iam::${account.id}:role/InfrastructureEC2Access`,
              RoleSessionName: 'EC2TagChanging',
              Policy: policy
            }).promise());
          }
        })
        .then(res => {
          // accessing the instances.


          const accessKeyId = res.Credentials.AccessKeyId;
          const secretAccessKey = res.Credentials.SecretAccessKey;
          const sessionToken = res.Credentials.SessionToken;
          EC2 = new AWS.EC2({region, accessKeyId, secretAccessKey, sessionToken});
          return EC2.describeReservedInstances({}).promise();
        })
        .then(res => {
          const instances = [];
          instances.push(...res.ReservedInstances);
          instances.forEach(ele => {
            ele.region = region;
            ele.accountId = account.id;
            ele.accountName = account.name;
            ele.hidden = 'False';
            if (ele.accountName === 'Weaveability') {
              if (ele.Tags.find(tag => tag.Key === 'Client')) {
                ele.accountName = ele.Tags.find(tag => {
                  return tag.Key === 'Client';
                }).Value;
              } else ele.accountName = '*NO CLIENT*';
            };
          });
          currentProfile++;
          allInstances.push(...instances);
          if (currentProfile === totalProfiles) allInstancesFound();
        })
        .catch(err => {
          console.log(region);
          console.log(account);
          console.log(err);
          currentProfile++;
          if (currentProfile === totalProfiles) allInstancesFound();
        });

      });
    });

    const allInstancesFound = () => {
      resolve(allInstances);
    };

  });

};


// WEBPACK FOOTER //
// ./src/components/content/ec2ResExplorer/utils/getAllInstances.js